module.exports = __webpack_public_path__ + "img/ipad-hero_en.e95432e.jpg";